import { render } from "./BancaOre.vue?vue&type=template&id=e2b66ad0&scoped=true&ts=true"
import script from "./BancaOre.vue?vue&type=script&lang=ts"
export * from "./BancaOre.vue?vue&type=script&lang=ts"

import "./BancaOre.vue?vue&type=style&index=0&id=e2b66ad0&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b66ad0"]])

export default __exports__